import React, { useEffect, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

import searchBtn from '../../images/looking-glass.svg';
import FilterDispatch from '../../contexts/filterDispatch';
import filterActions from '../../actions/filter.actions';

import Input from './Input';
import style from './SearchClient.module.css';

const SearchClient = React.memo(({ history }) => {
  const params = useMemo(() => new URLSearchParams(history.location.search), [history.location.search]);
  const q = params.get('q');

  const [query, setQuery] = useState(q || '');
  const [search, setSearch] = useState(false);

  const dispatch = useContext(FilterDispatch);

  const handleSearch = event => {
    event.preventDefault();

    if (query !== params.get('q')) {
      setSearch(true);
    }
  };

  const handleSearchChange = event => {
    event.preventDefault();
    
    setQuery(event.target.value);
  };

  useEffect(() => {
    if (search) {
      params.set('q', query);
      params.set('page', 0);

      history.push(`${history.location.pathname}?${params.toString()}`);
      setSearch(false);

      dispatch({
        type: filterActions.FILTER_CHANGED_SUCCESS,
      });
    }
  }, [dispatch, params, query, search, history]);

  return (
    <section className={style.main}>
      <form onSubmit={handleSearch}>
        <div className={`form-group ${style.formGroup}`}>
          <Input
            name="q"
            id="q"
            value={query}
            onChange={handleSearchChange}
            autocomplete="off"
            placeholder="Search by Name, Client ID, Client Code, Phone #, or Policy #"
            styles={style.searchBox}
          />
          <button
            type="submit"
            className={style.searchBtn}
            onClick={handleSearch}
          >
            <img src={searchBtn} alt="search" />
          </button>
        </div>
      </form>
    </section>
  );
});

SearchClient.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  history: PropTypes.object.isRequired,
};

export default SearchClient;
